import A from 'const/actionTypes'
import actions from '.'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'

export default {
  setOtherGamer: (otherGamer) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.SET_OTHER_GAMER,
        otherGamer
      })
    }
  },
  startListeningToOtherGamer: (gamerId) => {
    return (dispatch, getState) => {
      firebaseService.subscribe(
        'gamers/' + gamerId,
        (result) => {
          const otherGamer = result.val() || {}

          if (Object.keys(otherGamer).length) {
            dispatch(actions.setOtherGamer(otherGamer))
            dispatch(actions.setOtherGamerProfile(gamerId))
          }
        },
        N.GAMERS
      )
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/otherGamer.js